import EntitiesPage from '../pages/entities-page.vue'
import NewEntitiesPage from '../pages/new-entities-page.vue'
export default [
  {
    component: EntitiesPage,
    name: 'admin.entities',
    path: '/:slug/admin/entities',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.all-group',
    path: '/:slug/admin/all-group',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.managed-funds',
    path: '/:slug/admin/managed-funds',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.managed-spvs',
    path: '/:slug/admin/managed-spvs',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.funds-in-progress',
    path: '/:slug/admin/funds-in-progress',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.spv-in-progress',
    path: '/:slug/admin/spv-in-progress',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.fund-formation-in-progress',
    path: '/:slug/admin/fund-formation-in-progress',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.spvs-on-hold',
    path: '/:slug/admin/spvs-on-hold',
  },
]
